import {AddOutsidePersonController} from './add-outside-person/add-outside-person.component';
import addAuthorizedOutsidePersonTemplate from './add-outside-person/add-outside-person.html';
import {EditOutsidePersonController} from './edit-outside-person/edit-outside-person.component';
import editAuthorizedOutsidePersonTemplate from './edit-outside-person/edit-outside-person.html';
import template from './manage-student.html';

import './manage-student.scss';
import moment from 'moment';

class ManageStudentComponent {
  constructor($log, $mdToast, $mdDialog, StudentService, PinCodeService, UtilService) {
    'ngInject';
    this.$log = $log;
    this.$mdToast = $mdToast;
    this.$mdDialog = $mdDialog;
    this.StudentService = StudentService;
    this.PinCodeService = PinCodeService;
    this.UtilService = UtilService;
    this.authorizedOutsidePersons = [];
    this.weekdaysMap = this.UtilService.getWeekDaysMap();
    this.weekdayKeys = Object.keys(this.weekdaysMap);
    this.formPermissionsSchedule = {};
    this.allDay = {};
  }

  $onInit() {
    this.initDaysFromSchedule();
    this.fetchAuthorizedOutsidePersons();
  }

  $onChanges(changes) {
    if (changes.student && this.formData) {
      this.initDaysFromSchedule();
    }
  }

  fetchAuthorizedOutsidePersons() {
    if (this.student.studentUserId) {
      this.loading = true;
      this.PinCodeService.getAuthorizedOutsidePerson(this.student.studentUserId)
        .then(result => {
          this.loading = false;
          this.authorizedOutsidePersons = result;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }

  addAuthorizedOutsidePerson(event) {
    event.stopPropagation();
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: '$ctrl',
      controller: AddOutsidePersonController,
      template: addAuthorizedOutsidePersonTemplate,
      disableParentScroll: true,
      clickOutsideToClose: false,
      targetEvent: event,
      locals: {student: this.formData},
      multiple: true
    })
      .then(response => {
        this.authorizedOutsidePersons.push(response);
      });
  }

  editAuthorizedOutsidePerson(event, person) {
    event.stopPropagation();
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: '$ctrl',
      controller: EditOutsidePersonController,
      template: editAuthorizedOutsidePersonTemplate,
      disableParentScroll: true,
      clickOutsideToClose: false,
      targetEvent: event,
      locals: {person},
      multiple: true
    })
      .then(() => {
        this.fetchAuthorizedOutsidePersons();
      });
  }

  removeAuthorizedOutsidePerson(event, person) {
    const confirm = this.$mdDialog.confirm()
      .multiple(true)
      .title('')
      .textContent('Czy na pewno chcesz usunąć osobę uprawnioną?')
      .ariaLabel('Czy na pewno chcesz usunąć osobę uprawnioną?')
      .targetEvent(event)
      .ok('Usuń')
      .cancel('Anuluj');

    this.$mdDialog.show(confirm)
      .then(() => {
        this.PinCodeService.removeAuthorizedOutsidePerson(person.outsidePersonId)
          .then(() => {
            this.fetchAuthorizedOutsidePersons();
            this.$mdToast.show(
              this.$mdToast.simple()
                .textContent('Usunięto osobę uprawnioną')
                .position('bottom right')
                .hideDelay(3000)
            );
          })
          .catch(error => {
            this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {error}
              })
            );
          });
      });
  }

  initDaysFromSchedule() {
    Object.values(this.formData.permissionsSchedule).forEach(entry => {
      if (angular.isString(entry.hour)) {
        const date = moment().format('YYYY-MM-DD');
        entry.hour = moment(`${date} ${entry.hour}:00`).toDate();
      }
    });
    const schedule = this.formData.permissionsSchedule || {};
    this.formPermissionsSchedule = this.weekdayKeys.filter(d => {
      const t = schedule[d]?.type;
      return t === 'whole_day' || t === 'specific_hour';
    });
    this.formPermissionsSchedule.forEach(d => {
      this.allDay[d] = schedule[d]?.type === 'whole_day';
    });
  }

  getDayName(dayKey) {
    return this.weekdaysMap[dayKey];
  }

  onDaysChange() {
    const schedule = this.formData.permissionsSchedule || (this.formData.permissionsSchedule = {});
    this.formPermissionsSchedule.forEach(dayKey => {
      if (!schedule[dayKey] || schedule[dayKey].type === 'no') {
        schedule[dayKey] = {type: 'whole_day', hour: null};
        this.allDay[dayKey] = true;
      }
    });
    this.formPermissionsSchedule.sort((a, b) => this.UtilService.weekdaysSortOrder[a] - this.UtilService.weekdaysSortOrder[b]);
    this.weekdayKeys.forEach(dayKey => {
      if (this.formPermissionsSchedule && this.formPermissionsSchedule.includes(dayKey)) {
        return;
      }

      schedule[dayKey] = {type: 'no', hour: null};
      delete this.allDay[dayKey];
    });
    if (this.formPermissionsSchedule.length === 0) {
      this.formData.isPermittedToLeaveOnOwn = false;
    }
  }

  onIsPermittedToLeaveOnOwnChange() {
    if (this.formData.isPermittedToLeaveOnOwn === true && this.formPermissionsSchedule.length === 0) {
      this.weekdayKeys.forEach(dayKey => {
        this.formData.permissionsSchedule[dayKey] = {type: 'whole_day', hour: null};
        this.initDaysFromSchedule();
      });
    }
  }

  onAllDayChanged(dayKey) {
    const schedule = this.formData.permissionsSchedule[dayKey];
    if (this.allDay[dayKey]) {
      schedule.type = 'whole_day';
      schedule.hour = null;
    } else {
      schedule.type = 'specific_hour';
    }
  }

  onHourChanged(dayKey) {
    const schedule = this.formData.permissionsSchedule[dayKey];
    if (this.formPermissionsSchedule.indexOf(dayKey) !== -1) {
      schedule.type = 'specific_hour';
      this.allDay[dayKey] = false;
    }
  }
}

export const ManageStudent = {
  bindings: {
    student: '<',
    formData: '='
  },
  controller: ManageStudentComponent,
  template
};
